/**
 * @fileoverview GET handler for the "/integrations/voucher_group/:id/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { integrationsVoucherGroupIdAppGroupId } from "./constants";
import type { IntegrationsVoucherGroupIdAppGroupIdResult } from "./types";
import { isIntegrationsVoucherGroupIdAppGroupIdResult } from "./validators";

export const getIntegrationsVoucherGroupIdAppGroupId = reactQueryFetcherAdapter(
  integrationsVoucherGroupIdAppGroupId,
  (signal: AbortSignal, id: string, appGroupId: string): Promise<IntegrationsVoucherGroupIdAppGroupIdResult> => {
    return fetch(`/integrations/voucher_group/${id}/${appGroupId}`, "GET", {}, { signal });
  },
  isIntegrationsVoucherGroupIdAppGroupIdResult
);
